<script setup>
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';

const emit = defineEmits(['click']);

const { t } = useI18n();
</script>

<template>
  <EmptyStateLayout
    compact
    class="h-full"
    icon="i-lucide-sparkles"
    :title="t('CAPTAIN.ASSISTANTS.EMPTY_STATE.TITLE')"
    :subtitle="t('CAPTAIN.ASSISTANTS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #actions>
      <Button
        :label="t('CAPTAIN.ASSISTANTS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </template>
  </EmptyStateLayout>
</template>
